
<div class="text-gray-900 flex flex-col gap-2 justify-center items-center h-full">
  <img [src]="(reason() !== 'noavailability' && reason() !== 'noserviceforlanguage') ? '/icons/exclamation-red.svg' : '/icons/exclamation-blue.svg'" class="h-9 w-9"/>
  <div class="font-bold  text-lg">
    {{title}}
  </div>
  <div class="font-normal text-base text-center">
    {{content}}
  </div>
  @if (button != undefined) {
    <div class="flex gap-4">
      @for (link of button; track link){
        <div class="py-4 px-6">
          <div (click)="goToPage(formatPipe.transform(link.action, { branchID: branch}))" [class]="link.type === 'primary' ? 'text-white bg-afcu-navy-800 border-afcu-navy-800' : 'text-afcu-navy-800 border border-afcu-navy-800'" class="py-3 px-5 font-semibold cursor-pointer">{{link.title}}</div>
          <!-- <a [routerLink]="[formatPipe.transform(link.action, { branchID: branch})]" routerLinkActive="active" [queryParamsHandling]="'preserve'" [class]="link.type === 'primary' ? 'text-white bg-afcu-navy-800 border-afcu-navy-800' : 'text-afcu-navy-800 border border-afcu-navy-800'" class="py-3 px-5 font-semibold cursor-pointer">{{link.title}}</a> -->
        </div>
      }
    </div>
    
  }
</div>


